module.exports = __webpack_public_path__ + "img/earth-americas.b71931b1.svg";